import React from "react";
import cs from "classnames";
import classes from "./SubmitAnswerButton.module.scss";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const SubmitAnswerButton = ({ submitAnswer, size, color }) => {
  const { t } = useTranslation();

  return (
    <div className={cs(classes.previewButton, classes[size], classes[color])} onClick={submitAnswer}>
      {t("pages.mymaor.preview_button.submit_answer")}
    </div>
  );
};

SubmitAnswerButton.propTypes = {
  submitAnswer: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default SubmitAnswerButton;
